// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"277":"1480c00e","523":"913079af","617":"3bfa3a1c","712":"49e0c373"}[chunkId] + ".js";
};